import Dexie from 'dexie';

const db = new Dexie('DHR_DB');
// const fields = ["EmployeeID", "EmployeeName", "UserPictureURL", "DepartmentID", "DepartmentName", "DutyID", "DutyName",
//     "ProjectID", "ProjectName", "Telephone", "DateJoined","UserID", "UserName", "Email", "PersonalEmail"];
db.version(1).stores({ userCache: '++id,time,data' });

export default db;